import { useState } from 'react';
import './TechStack.css'; // Assuming you have a CSS file for styles

import {FaReact,FaVuejs,FaAngular,FaLaravel,FaNodeJs,FaWordpress,FaShopify,FaBuffer,FaMailchimp,FaSwift,FaUikit,FaJava,FaAws,FaDocker,FaJenkins,FaFigma,FaGitlab} from 'react-icons/fa';
import {FaFlutter} from 'react-icons/fa6';
import {SiNextdotjs,SiSvelte,SiExpress,SiDjango,SiFlask,SiGoogleanalytics,SiSemrush,SiHootsuite,SiSendgrid,SiKotlin,SiJetpackcompose,SiIonic,SiMysql,SiPostgresql,SiSqlite,SiMongodb,SiRedis,SiFirebase,SiGooglecloud,SiVercel,SiNetlify,SiKubernetes,SiAdobephotoshop,SiAdobeillustrator} from 'react-icons/si';


const TechnologiesWeUse = () => {
  const [activeTab, setActiveTab] = useState('Web Platforms');


const techCategories = [
  {
    title: "Web Platforms",
    subcategories: [
      {
        title: "Front-end technologies",
        technologies: [
          { name: "React", icon: FaReact },
          { name: "Next.js", icon: SiNextdotjs },
          { name: "Vue.js", icon: FaVuejs },
          { name: "Angular", icon: FaAngular },
          { name: "Svelte", icon: SiSvelte },
          { name: "Laravel", icon: FaLaravel },
        ],
      },
      {
        title: "Back-end Development",
        technologies: [
          { name: "Node.js", icon: FaNodeJs },
          { name: "Express", icon: SiExpress },
          { name: "Django", icon: SiDjango },
          { name: "Flask", icon: SiFlask },
        ],
      },
      {
        title: "CMS Development",
        technologies: [
          { name: "WordPress", icon: FaWordpress },
          { name: "Shopify", icon: FaShopify },
        ],
      },
    ],
  },
  {
    title: "Digital Marketing",
    subcategories: [
      {
        title: "SEO & Analytics Tools",
        technologies: [
          { name: "Google Analytics", icon: SiGoogleanalytics },
          { name: "SEMrush", icon: SiSemrush },
          // { name: "GTMetrix", icon: SiGtmetrix },
        ],
      },
      {
        title: "Social Media Tools",
        technologies: [
          { name: "Hootsuite", icon: SiHootsuite },
          { name: "Buffer", icon: FaBuffer },
          // { name: "Sprout Social", icon: SiSprout },
        ],
      },
      {
        title: "Email Marketing Tools",
        technologies: [
          { name: "Mailchimp", icon: FaMailchimp },
          { name: "SendGrid", icon: SiSendgrid },
          // { name: "Constant Contact", icon: SiConstantcontact },
        ],
      },
    ],
  },
  {
    title: "Mobile Apps",
    subcategories: [
      {
        title: "iOS Development",
        technologies: [
          { name: "Swift", icon: FaSwift },
          { name: "UI Kit", icon: FaUikit },
          // { name: "RxSwift", icon: SiRxswift },
          // { name: "Combine", icon: SiCombine },
          // { name: "MVVM", icon: SiCombine },
          // { name: "Alamofire", icon: SiAlamofire },
          // { name: "Core Data", icon: SiCoredata },
        ],
      },
      {
        title: "Android Development",
        technologies: [
          { name: "Kotlin", icon: SiKotlin },
          // { name: "MVVM", icon: SiCombine },
          // { name: "RxJava", icon: SiRxjava },
          { name: "Java", icon: FaJava },
          // { name: "Retrofit", icon: SiRetrofit },
          { name: "Jetpack", icon: SiJetpackcompose },
        ],
      },
    ],
  },
  {
    title: "Cross Platforms",
    subcategories: [
      {
        title: "React Native",
        technologies: [
          { name: "React", icon: FaReact },
          { name: "Next.js", icon: SiNextdotjs },
          { name: "Vue.js", icon: FaVuejs },
          { name: "Angular", icon: FaAngular },
        ],
      },
      {
        title: "Flutter",
        technologies: [
          { name: "React Native", icon: FaReact },
          { name: "Flutter", icon: FaFlutter },
          { name: "Ionic", icon: SiIonic },
        ],
      },
    ],
  },
  {
    title: "Database",
    subcategories: [
      {
        title: "SQL",
        technologies: [
          { name: "MySQL", icon: SiMysql },
          { name: "PostgreSQL", icon: SiPostgresql },
          { name: "SQLite", icon: SiSqlite },
        ],
      },
      {
        title: "NoSQL",
        technologies: [
          { name: "MongoDB", icon: SiMongodb },
          // { name: "Cassandra", icon: SiCassandra },
          { name: "Redis", icon: SiRedis },
          { name: "Firebase Realtime Database", icon: SiFirebase },
        ],
      },
    ],
  },
  {
    title: "Cloud & DevOps",
    subcategories: [
      {
        title: "Cloud Providers",
        technologies: [
          { name: "AWS", icon: FaAws },
          // { name: "Azure", icon: SiMicrosoftazure },
          { name: "Google Cloud", icon: SiGooglecloud },
          { name: "Vercel", icon: SiVercel },
          { name: "Netlify", icon: SiNetlify },
        ],
      },
      {
        title: "DevOps Tools",
        technologies: [
          { name: "Docker", icon: FaDocker },
          { name: "Kubernetes", icon: SiKubernetes },
          { name: "Jenkins", icon: FaJenkins },
          { name: "GitLab CI/CD", icon: FaGitlab },
        ],
      },
    ],
  },
  {
    title: "Design & Prototyping",
    subcategories: [
      {
        title: "Design Tools",
        technologies: [
          { name: "Figma", icon: FaFigma },
          { name: "Photoshop", icon: SiAdobephotoshop },
          { name: "Illustrator", icon: SiAdobeillustrator },
        ],
      },
    ],
  },
];

  const activeCategory = techCategories.find(cat => cat.title === activeTab);

  return (
    <section className="technology overflow-x-hidden sm:overflow-x-auto bg-gradient-to-b from-gray-900 to-gray-950">
  <div className="px-4 lg:px-8 pt-6 md:pt-4 lg:pt-8 max-w-7xl mx-auto">
    <div className="max-w-3xl xl:max-w-4xl mx-auto sm:px-4">
      <div className="lg:overflow-hidden">
        <h2 className="font-bold text-4xl xl:text-5xl 2xl:text-6xl tracking-tight text-transparent bg-clip-text bg-gradient-to-r from-blue-500 to-purple-600 pb-1">
          <span className="inline-block">Technologies we use</span>
        </h2>
      </div>
      <p className="lg:pt-8 pt-6 text-base md:text-lg lg:text-xl xl:text-xl 2xl:text-2xl text-gray-300 leading-relaxed">
        Hire from our pool of 20+ specialized experts in web, mobile, and software engineering,Digital Marketing 
        specializing in the latest technologies and frameworks, ready to scale your development projects effortlessly.
      </p>
    </div>

    <div className="flex flex-col md:flex-row mt-10 md:mt-12 lg:mt-16 md:border-t border-gray-700/50 px-2">
      {/* Tab Navigation */}
      <div className="scrollbar-hide w-full md:w-[30%] lg:w-[21.5%] 2xl:w-[24%] overflow-auto md:overflow-hidden md:border-r border-gray-700/50 md:pt-8 md:border-b-0 border-b">
        <div className="flex md:flex-col gap-x-5 md:gap-y-2" role="tablist" aria-orientation="horizontal">
          {techCategories.map((category) => (
            <button
              key={category.title}
              onClick={() => setActiveTab(category.title)}
              className={`focus-visible:outline-none transition-all duration-200 ${
                activeTab === category.title ? 'home-module--techActive--abf49' : ''
              }`}
              role="tab"
              type="button"
              aria-selected={activeTab === category.title}
            >
              <div className="z-10 whitespace-nowrap md:whitespace-normal outline-none md:w-full py-3 md:px-6 font-medium text-left group">
                <h2 className={`font-medium block text-lg xl:text-xl 2xl:text-2xl outline-none tracking-normal truncate transition-all ${
                  activeTab === category.title 
                    ? 'font-bold bg-gradient-to-r from-blue-400 to-purple-400 bg-clip-text text-transparent' 
                    : 'text-gray-300 group-hover:text-white'
                }`}>
                  {category.title}
                </h2>
              </div>
            </button>
          ))}
        </div>
      </div>

      {/* Tab Content */}
      <div className="pt-8 w-full md:w-8/12 lg:w-9/12 md:ps-10 lg:pb-8 rounded-lg">
        {activeCategory?.subcategories?.map((subcategory) => (
          <div key={subcategory.title} className="mb-12 text-white">
            <h4 className="mb-8 font-bold text-xl xl:text-2xl 2xl:text-[1.75rem] tracking-wide text-center text-cyan-400/90">
              {subcategory.title}
            </h4>
            <div className="flex flex-wrap gap-4 md:gap-5 lg:gap-6 justify-center">
              {subcategory.technologies.map((tech) => (
                <div 
                  className="group w-[140px] md:w-36 lg:w-40 bg-gray-800/70 hover:bg-gray-700/80 px-4 py-4 border border-gray-700 rounded-xl sm:rounded-2xl font-medium md:text-base text-sm hover:border-indigo-400/50 transition-all duration-300 flex flex-row items-center gap-3 hover:shadow-lg hover:shadow-indigo-500/10 text-white hover:-translate-y-1"
                >
                  <div className="text-3xl md:text-2xl lg:text-3xl text-indigo-400/90 flex-shrink-0">
                    {tech.icon && <tech.icon />}
                  </div>
                  <div className="text-left overflow-hidden w-full">
                    <span className="block group-hover:translate-x-1 transition-transform">
                      {tech.name}
                    </span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  </div>
</section>
  );
};

export default TechnologiesWeUse;